import { Toast } from "../components/notify/Notify";
import { url } from "../constants/path";
import api, { handleErrorCreateAndUpdate } from "../services/api";
import {
  getLocalAccessToken,
  setLocalAccessToken,
  setLocalRefreshToken,
  setLocalUser,
} from "../utils/helper";

const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.auth;

export const getProfileEmployee = (id, callback) => {
  api
    .get(`${URL}/profile/${id}`)
    .then((response) => callback(response.data.data))
    .catch((err) => {
      console.log(err);
      Toast("warning", err.response.data.message);
    });
};

export const login = (data, callback) => {
  api
    .post(`${URL}/login`, data)
    .then((response) => {
      api.defaults.headers.common["Authorization"] =
        "Bearer " + response.data.data.access_token;
      getProfileEmployee(response.data.data.id, (result) => {
        setLocalUser(result);
        setLocalAccessToken(response.data.data.access_token);
        setLocalRefreshToken(response.data.data.refresh_token);
        callback(result);
        Toast("success", "Sign Up Successful");
      });
    })
    .catch((err) => handleErrorCreateAndUpdate(err, callback));
};

export const logout = (data, callback) => {
  api
    .post(`${URL}/logout`, data)
    .then((result) => {
      callback(result);
      Toast("success", "Thành công");
    })
    .catch((err) => Toast("warning", err.response.data.message));
};

export const changePassword = (data, callback) => {
  api
    .post(`${URL}/change-password`, data)
    .then((response) => {
      api.defaults.headers.common["Authorization"] =
        "Bearer " + response.data.data.access_token;
      setLocalAccessToken(response.data.data.access_token);
      setLocalRefreshToken(response.data.data.refresh_token);
      callback(response.data.data);
      Toast("success", "Successful");
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};
